import { action, makeAutoObservable, makeObservable, observable } from "mobx"

import {
  getFilterSimpleFiled,
  prepares,
} from "@src/shared/componemts/TableFilter/classes/constants"
import {
  FiltersFieldType,
  TableFilterProps,
} from "@src/shared/componemts/TableFilter/types"

export class CollectionFilters<T extends object> {
  state = {} as T

  constructor(
    public config: FiltersFieldType[],
    private onUpdate?: (v: T) => void,
  ) {
    makeObservable(this, {
      config: observable,
      onFormChange: action.bound,
      state: observable.deep,
      updateConfig: action.bound,
    })
  }

  static createField(name: string) {
    return getFilterSimpleFiled(name)
  }

  static prepares(value: unknown) {
    return prepares(value)
  }

  onFormChange(state: T) {
    this.state = {
      ...state,
    }

    if (this.onUpdate) {
      this.onUpdate(this.state)
    }
  }

  updateConfig(config: FiltersFieldType[]) {
    this.config = [...config]
  }

  get isActive() {
    return Object.values(this.state).some(Boolean)
  }

  get props(): TableFilterProps {
    return {
      fields: this.config,
      onChange: this.onFormChange,
      state: this.state,
    }
  }
}
